<script>
export default {
  functional: true,
  name: 'Variable',
  props: {
    config: Object,
    index: Number
  },
  render: function(createElement, context) {
    if(context.props.config.type == 'char' && context.props.index < 26){
      return createElement(
	'span',
	[ context.props.config.charList[context.props.index] ]
      );
    }
    return createElement(
      'span',
      [
	context.props.config.character,
	createElement('sub',[String(context.props.index + 1)])
      ]
    );
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
